<template>
    <rkm-tabs
        :tab-refs="tabRefs"
        v-model="tabIndex"
    >
        <rkm-tab
            active
            title="Dados pessoais"
        >
            <FormDados
                :additionals="additionals"
                :form="form"
                :model="model"
                ref="FormDados"
            />
        </rkm-tab>

        <rkm-tab title="Documentos">
            <FormDocumentos
                :additionals="additionals"
                :form="form"
                :model="model"
                ref="FormDocumentos"
            />
        </rkm-tab>

        <rkm-tab title="Contatos">
            <FormContatos
                :model="model"
                ref="FormContatos"
            />
        </rkm-tab>

        <rkm-tab title="Endereço">
            <FormEndereco
                :additionals="additionals"
                :disabled="!additionals.permite_alteracao_endereco"
                :form="form"
                :model="model"
                ref="FormEndereco"
            />
        </rkm-tab>

        <rkm-tab title="Informações complementares">
            <FormInformacoesComplementares
                :form="form"
                :model="model"
                ref="FormInformacoesComplementares"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>
// Components.
import FormContatos from './components/contatos/Form'
import FormDados from './components/dados/Form'
import FormDocumentos from './components/documentos/Form'
import FormEndereco from './components/endereco/Form'
import FormInformacoesComplementares from './components/informacoes-complementares/Form'

export default {
    components: {
        FormContatos,
        FormDados,
        FormDocumentos,
        FormEndereco,
        FormInformacoesComplementares,
    },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        validate() {
            return this.tabRefs[this.tabIndex].validate()
        },
    },
    mounted() {
        this.tabRefs = [
            this.$refs.FormDados,
            this.$refs.FormDocumentos,
            this.$refs.FormContatos,
            this.$refs.FormEndereco,
            this.$refs.FormInformacoesComplementares,
        ]
    },
    props: {
        additionals: {type: Object, required: true},
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
}
</script> 